/* ==========================================================================
   Bolmar · ajustes do formulario COD (Releasit)
   Monta o form no mesmo formato do paccinozapatos.shop, com os assets da Bolmar:
     - selo de garantia e trio de icones no topo do form
     - nota vermelha + faixa do WhatsApp logo abaixo do campo de WhatsApp
     - esconde os campos que a loja nao usa (Last name, Zip code, Email, nota,
       newsletter e cupom), que o painel do app nao deixou desativar
   O modal e injetado por JS pelo app, entao observamos o DOM ate ele aparecer.
   ========================================================================== */
(function () {
  'use strict';

  var CDN = 'https://cdn.shopify.com/s/files/1/0779/9416/4418/files/';
  var IMG = {
    selo: CDN + 'bolmar-selo-garantia-cambio.png',
    trust: CDN + 'bolmar-set-3-iconos-confianza.png',
    whatsapp: CDN + 'bolmar-faixa-whatsapp.png',
    sorteo: CDN + 'bolmar-iphone18-sorteo.jpg?v=1792262971'
  };

  // Os campos extras (Last name, Zip code, Email, Order note) sao desativados
  // direto no painel do Releasit, em Form Designer > toggles de campo.
  // Aqui fica so o cupom, que o app nao permite desligar.
  var HIDE_PLACEHOLDERS = ['Discount code'];
  var HIDE_TEXTS = [];

  function fieldWrapper(el) {
    // sobe no maximo 2 niveis procurando o container do proprio campo.
    // NUNCA retorna um container que tenha outros campos dentro, senao
    // esconder um campo derrubaria o formulario inteiro.
    var node = el;
    for (var i = 0; i < 2 && node && node.parentElement; i++) {
      var parent = node.parentElement;
      var inputsDentro = parent.querySelectorAll('input, select, textarea').length;
      if (inputsDentro > 1) break;      // o pai ja agrupa mais de um campo: para aqui
      if (parent.classList && parent.classList.contains('rsi-form-content-wrapper')) break;
      node = parent;
    }
    return node;
  }

  // so marca quem ainda nao esta marcado: evita disparar mutation a toa
  function markHidden(el) {
    var w = fieldWrapper(el);
    if (w && w.getAttribute('data-bolmar-hide') !== '1') {
      w.setAttribute('data-bolmar-hide', '1');
      return true;
    }
    return false;
  }

  function hideUnusedFields(root) {
    var changed = false;
    HIDE_PLACEHOLDERS.forEach(function (ph) {
      Array.prototype.slice.call(
        root.querySelectorAll('input[placeholder="' + ph + '"], textarea[placeholder="' + ph + '"]')
      ).forEach(function (input) { if (markHidden(input)) changed = true; });
    });
    HIDE_TEXTS.forEach(function (txt) {
      Array.prototype.slice.call(root.querySelectorAll('label, div, span')).forEach(function (el) {
        if (el.children.length < 2 && (el.innerText || '').trim() === txt) {
          if (markHidden(el)) changed = true;
        }
      });
    });
    // botao de aplicar cupom, que fica solto ao lado do input escondido
    Array.prototype.slice.call(root.querySelectorAll('button')).forEach(function (b) {
      if ((b.innerText || '').trim() === 'Apply') { if (markHidden(b)) changed = true; }
    });
    return changed;
  }

  // Os cards de oferta (1un / 2un) vem do app com preco e selo na MESMA linha,
  // e em 390px o preco quebrava no meio ("$281. / 850,00"). O app nao tem opcao
  // de layout pra isso e as classes dele sao sc-* geradas (mudam a cada build),
  // entao marcamos os nos aqui e o CSS mira nas marcacoes.
  function marcarOfertas() {
    var titulos = document.querySelectorAll('.rsi-quantity-title-wrapper');
    for (var i = 0; i < titulos.length; i++) {
      var card = titulos[i];
      for (var k = 0; k < 6 && card.parentElement; k++) card = card.parentElement;
      if (card.getAttribute('data-bolmar-oferta') === '1') continue;

      // o selo e a folha que diz "Ahorra ..." ou o texto de destaque
      var folhas = card.querySelectorAll('*');
      var selo = null;
      for (var j = 0; j < folhas.length; j++) {
        var e = folhas[j];
        if (e.children.length === 0 && /Ahorra|vendido|Save/i.test(e.textContent || '')) { selo = e; break; }
      }
      if (!selo) continue;

      card.setAttribute('data-bolmar-oferta', '1');
      var caixa = selo.parentElement;                 // o "pill" do selo
      caixa.setAttribute('data-bolmar-selo', '1');
      var linha = caixa.parentElement;                // a linha preco + selo
      if (linha) linha.setAttribute('data-bolmar-linha', '1');
    }
  }

  function mediaBlock(src, alt, extraClass) {
    var wrap = document.createElement('div');
    wrap.className = 'bolmar-cod-media' + (extraClass ? ' ' + extraClass : '');
    wrap.setAttribute('data-bolmar-injected', '1');
    var img = document.createElement('img');
    img.src = src;
    img.alt = alt || '';
    img.loading = 'lazy';
    wrap.appendChild(img);
    return wrap;
  }

  function injectTopMedia(content) {
    if (content.querySelector('[data-bolmar-top]')) return;
    var holder = document.createElement('div');
    holder.setAttribute('data-bolmar-top', '1');
    // selo de garantia fora do form do Bolso Carriel (pedido do Nelson 30/09)
    if (!/\/products\/(bolso-carriel|morral-velez|trio-dacota)/.test(location.pathname)) {
      holder.appendChild(mediaBlock(IMG.selo, 'Garantia de cambio Bolmar', 'bolmar-cod-media--selo'));
    }
    holder.appendChild(mediaBlock(IMG.trust, 'Envios gratis, pago en casa, negocio confiable'));
    // banner do sorteio do iPhone 18 Pro logo abaixo dos selos (pedido do Nelson 17/10)
    holder.appendChild(mediaBlock(IMG.sorteo, 'Por tu compra participas por un iPhone 18 Pro'));
    content.insertBefore(holder, content.firstChild);
  }

  function injectWhatsappBlock(root) {
    var phone = root.querySelector('input[placeholder="Whatsapp"], input[type="tel"]');
    if (!phone) return;
    var wrapper = fieldWrapper(phone);
    if (wrapper.parentElement && wrapper.parentElement.querySelector('[data-bolmar-wa]')) return;

    var holder = document.createElement('div');
    holder.setAttribute('data-bolmar-wa', '1');

    var note = document.createElement('span');
    note.className = 'bolmar-wa-note';
    note.textContent = '*Tu WhatsApp para enviarte notificación de tu pedido';
    holder.appendChild(note);
    holder.appendChild(mediaBlock(IMG.whatsapp, 'Su pedido sera confirmado por WhatsApp'));

    if (wrapper.parentElement) {
      wrapper.parentElement.insertBefore(holder, wrapper.nextSibling);
    }
  }

  // O trio de icones tambem entra logo abaixo do botao de compra, na propria
  // pagina do produto. Cuidado: o botao "Comprar Ahora" existe 3x na pagina com
  // o MESMO id (dentro do form add-to-cart, o flutuante e o do cart drawer).
  // So o de dentro do form leva os icones: no flutuante ficaria cobrindo a tela
  // e no drawer nem aparece pra quem esta comprando.
  function injectTrustUnderBuyButton() {
    var botoes = document.querySelectorAll(
      '#rsi_buy_now_button, ._rsi-buy-now-button, .rsi-app-block-container button[id^="rsi_buy_now"]'
    );
    Array.prototype.slice.call(botoes).forEach(function (btn) {
      if (btn.closest('.rsi_floating, ._rsi-buy-now-button-floating, #floatingBuyNowButton')) return;
      if (btn.classList.contains('_rsi-buy-now-button-floating')) return;
      if (btn.closest('cart-drawer, #CartDrawer, .drawer, .cart-drawer')) return;

      // ancora no container do botao, para o icone ficar irmao dele
      var host = btn.closest('.rsi-app-block-container') || btn.parentElement;
      if (!host || host.querySelector('[data-bolmar-trust-btn]')) return;

      var bloco = mediaBlock(IMG.trust, 'Envios gratis, pago en casa, negocio confiable',
                             'bolmar-cod-media--under-btn');
      bloco.setAttribute('data-bolmar-trust-btn', '1');

      var ancora = (host === btn.parentElement) ? btn : host.lastElementChild;
      if (ancora && ancora.parentElement) {
        ancora.parentElement.insertBefore(bloco, ancora.nextSibling);
      } else {
        host.appendChild(bloco);
      }

      // banner do sorteio do iPhone 18 Pro logo abaixo dos selos (pedido do Nelson 17/10)
      var sorteo = mediaBlock(IMG.sorteo, 'Por tu compra participas por un iPhone 18 Pro',
                              'bolmar-cod-media--under-btn');
      bloco.parentElement.insertBefore(sorteo, bloco.nextSibling);
    });
  }


  // O nome da taxa vem do painel do Releasit como "Envio GRATIS - Pago contra entrega".
  // Aqui ele e reescrito no formato do modelo: nome em negrito + prazo em cinza ao lado,
  // e o preco com a mesma capitalizacao. So texto, o valor real do radio nao muda.
  var ENVIO_NOME = 'Envio gratis';
  var ENVIO_PRAZO = '(1-5 Dias)';
  var ENVIO_PRECO = 'Gratis';

  function ajustarEnvio(root) {
    var titulos = root.querySelectorAll('.rsi-shipping-rates-title');
    Array.prototype.slice.call(titulos).forEach(function (t) {
      if (t.getAttribute('data-bolmar-envio') === '1') return;
      t.setAttribute('data-bolmar-envio', '1');
      t.textContent = ENVIO_NOME;
      var prazo = document.createElement('span');
      prazo.className = 'bolmar-envio-prazo';
      prazo.textContent = ENVIO_PRAZO;
      t.parentNode.insertBefore(prazo, t.nextSibling);
    });
    var precos = root.querySelectorAll('.rsi-shipping-rates-price');
    Array.prototype.slice.call(precos).forEach(function (p) {
      if (p.getAttribute('data-bolmar-envio') === '1') return;
      p.setAttribute('data-bolmar-envio', '1');
      p.textContent = ENVIO_PRECO;
    });
    // o radio unico ja vem marcado pelo app; garante caso venha desmarcado
    var r = root.querySelector('.rsi-shipping-rates-radio');
    if (r && !r.checked && root.querySelectorAll('.rsi-shipping-rates-radio').length === 1) {
      r.checked = true;
    }
  }


  // ------------------------------------------------------------------------
  // LINHA VÉLEZ (17/10): cabeçalho preto e ouro, resumo do pedido com a
  // economia e prova social no form. Só nas páginas Vélez; Papá Noel intacto.
  // Não toca nos campos, no botão de enviar nem no handler do app.
  // ------------------------------------------------------------------------
  var VLZ = {
    'morral-velez-cosmetiquera': { nome: 'Morral Vélez', tit: 'Tu Morral Vélez llega', extra: '+ Cosmetiquera a juego INCLUIDA', antes: 630000 },
    'bolso-carriel-velez-dama': { nome: 'Bolso Carriel Vélez', tit: 'Tu Bolso Vélez llega', extra: 'Correa tejida incluida', antes: 469000 },
    'trio-dacota': { nome: 'Trío Dacota Vélez', tit: 'Tu Trío Vélez llega', extra: 'Bolso grande + cruzado + cosmetiquera', antes: 0 }
  };
  var vlzHandle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  var vlz = vlzHandle && VLZ[vlzHandle];
  if (vlz) document.documentElement.setAttribute('data-bm-line', 'velez');
  var MINI = [
    ['LC', 'Llegó en 3 días y lo pagué en la puerta.', 'Laura, Cali'],
    ['RM', 'Lo revisé con calma antes de pagarle al mensajero.', 'Rosa Elena, Popayán'],
    ['SM', 'Pedí dos y llegaron completos con sus cosmetiqueras.', 'Sandra, Pereira']
  ];
  function cop(n) { return '$' + Math.round(n).toLocaleString('es-CO'); }
  function varianteAtual() {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var id = (new URLSearchParams(location.search)).get('variant');
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (inp && inp.value) id = inp.value;
    if (!meta || !meta.variants) return null;
    var v = meta.variants.filter(function (x) { return String(x.id) === String(id); })[0] || meta.variants[0];
    return { cor: v.public_title || v.name || '', preco: v.price / 100 };
  }
  function injectVelez(content) {
    // 20/10: Nelson pediu o form limpo, sem o cabecalho preto/ouro (ocupava espaco). Remove o que tiver sido injetado.
    content.querySelectorAll('[data-bm-vhead], [data-bm-vproof], .bmv-nota').forEach(function (e) { e.remove(); });
    return;
    if (!vlz) return;
    var v = varianteAtual();
    var head = content.querySelector('[data-bm-vhead]');
    if (!head) {
      head = document.createElement('div');
      head.setAttribute('data-bm-vhead', '1');
      head.setAttribute('data-bolmar-injected', '1');
      head.innerHTML = '<p class="bmv-eb">Último paso · Edición atelier</p><p class="bmv-tt">' + vlz.tit + '<em>y lo pagas en la puerta</em></p><div class="bmv-res"></div>';
      content.insertBefore(head, content.firstChild);
    }
    if (v) {
      var hoje = v.preco, ah = vlz.antes > hoje ? vlz.antes - hoje : 0;
      var html = '<div class="bmv-l1"><b>' + vlz.nome + (v.cor ? ' · Tono ' + v.cor : '') + '</b><span>' + vlz.extra + '</span></div>' +
        '<div class="bmv-l2">' + (ah ? '<s>' + cop(vlz.antes) + '</s>' : '') + '<b>' + cop(hoje) + '</b>' + (ah ? '<i>AHORRAS ' + cop(ah) + '</i>' : '') + '</div>' +
        '<div class="bmv-l3"><span>Envío <b>GRATIS</b></span><span>Hoy pagas <b>$0</b> · Al recibir <b>' + cop(hoje) + '</b></span></div>';
      var res = head.querySelector('.bmv-res');
      if (res.getAttribute('data-v') !== html) { res.innerHTML = html; res.setAttribute('data-v', html); }
    }
    // 20/10: prova social e nota ao lado do botao REMOVIDAS (espremiam o botao no form do Morral)
    document.querySelectorAll('[data-bm-vproof], .bmv-nota').forEach(function (e) { e.remove(); });
  }

  var observer = null;
  var running = false;
  var scheduled = false;

  function enhance() {
    if (running) return;
    running = true;
    // desliga o observer enquanto mexe no DOM, senao as proprias mudancas
    // disparam novas mutations e viram loop
    if (observer) observer.disconnect();
    try {
      // o botao existe na pagina mesmo sem o modal aberto, entao roda sempre
      injectTrustUnderBuyButton();
      marcarOfertas();
      var content = document.querySelector('.rsi-form-content-wrapper');
      if (content) {
        hideUnusedFields(content);
        injectTopMedia(content);
        injectWhatsappBlock(content);
        ajustarEnvio(content);
        injectVelez(content);
      }
    } catch (e) {
      /* nunca deixar um erro daqui quebrar o form do app */
    }
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
    running = false;
  }

  // agrupa rajadas de mutation numa chamada so
  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; enhance(); });
  }

  function start() {
    enhance();
    observer = new MutationObserver(scheduleEnhance);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// CTAs do meio da descricao (Morral: a.mv-cta "QUIERO MI MORRAL VELEZ" etc.;
// Carriel: a.bd-btn) levam data-bd-cta. Antes so subiam a pagina (href="#").
// Agora rolam ate o botao do Releasit "PIDE Y PAGA AL RECIBIR" e clicam nele,
// abrindo o formulario direto. Pedido do Nelson 27/10.
(function () {
  function rsiBtn() {
    var hooks = document.querySelectorAll('._rsi-buy-now-button-app-block-hook, .rsi-button-hook');
    for (var i = 0; i < hooks.length; i++) {
      var b = hooks[i].querySelector('button');
      if (b && b.offsetParent) return b;
    }
    var all = document.querySelectorAll('#rsi_buy_now_button, ._rsi-buy-now-button');
    for (var j = 0; j < all.length; j++) {
      if (all[j].offsetParent && !all[j].closest('cart-drawer, #CartDrawer')) return all[j];
    }
    return null;
  }
  function formOpen() {
    var d = document.querySelector('dialog.rsi-form-wrapper-dialog');
    return !!(d && d.open);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a.mv-cta, a[data-bd-cta]');
    if (!a) return;
    var btn = rsiBtn();
    if (!btn) return; // sem Releasit na pagina: deixa o link seguir
    e.preventDefault();
    try { btn.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) { btn.scrollIntoView(); }
    setTimeout(function () { if (!formOpen()) btn.click(); }, 450);
  }, true);
})();
